import { render, staticRenderFns } from "./BorderTable.vue?vue&type=template&id=02320592&scoped=true&"
import script from "./BorderTable.vue?vue&type=script&lang=js&"
export * from "./BorderTable.vue?vue&type=script&lang=js&"
import style0 from "./BorderTable.vue?vue&type=style&index=0&id=02320592&lang=scss&scoped=true&"
import style1 from "./BorderTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02320592",
  null
  
)

export default component.exports